import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OktaAuthStateService } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';

@Injectable()
export class AuthorizationHttpInterceptor implements HttpInterceptor {
  private _accessToken: string | undefined;

  constructor(_authStateService: OktaAuthStateService) {
    _authStateService.authState$.subscribe(
      (authState: AuthState) =>
        (this._accessToken = authState?.accessToken?.accessToken),
    );
  }

  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Clone the request to add the new header
    const authorizedRequest = httpRequest.clone({
      headers: httpRequest.headers.set(
        'Authorization',
        `Bearer ${this._accessToken}`,
      ),
    });

    // Send the newly created request
    return next.handle(authorizedRequest);
  }
}
